import { lazy } from "react";

const NotificationsView = lazy(() => import("./NotificationsView"));

const notificationsRoutes = [
  { path: "/notifications", element: <NotificationsView /> },
  { path: "/app/notifications", element: <NotificationsView /> }
];

export default notificationsRoutes;
